import {
  setAccountLinked,
  setEhrLinkedToOtherHeidiAccount,
  setHeidiLinkedToOtherEhrAccount,
} from '@/atoms/integrationAuthAtoms';
import { GET_LINKED_ACCOUNT_ACCESS } from '@/hooks/query/integrations/useQueryLinkedAccountAccess';
import { switchLinkedAccountToNewUser } from '@/pages/api/scribeOpenAPI';
import { isHeidiSupportReachable } from '@/utils/heidiReach';
import { formatMessageOutsideReact } from '@/utils/i18n/intl-bridge';
import { toast } from '@heidi/design-system/toast';
import { useTranslations } from '@heidi/runtime/i18n';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { defineMessages } from 'react-intl';

const messages = defineMessages({
  switchFailedContactIt: {
    defaultMessage: 'Failed to switch account. Please try again or contact your IT team.',
    id: 'ZEEbrx0qoK',
  },
});

type Props = {
  newKindeUserId: string;
};

export function useMutateSwitchLinkedAccountToNewUser() {
  const { t } = useTranslations();
  const queryClient = useQueryClient();

  return useMutation({
    retry: 0,
    mutationKey: ['switchLinkedAccountToNewUser'],
    mutationFn: async ({ newKindeUserId }: Props) => {
      return switchLinkedAccountToNewUser({ newKindeUserId });
    },
    onSuccess: (response) => {
      if (response?.data?.account) {
        setAccountLinked(true);
        setEhrLinkedToOtherHeidiAccount(false);
        setHeidiLinkedToOtherEhrAccount(false);
        void queryClient.invalidateQueries({ queryKey: [GET_LINKED_ACCOUNT_ACCESS] });
      }
    },
    onError: () => {
      toast({
        tone: 'destructive',
        title: t('common.error'),
        description: isHeidiSupportReachable
          ? t('integrations.auth.failedToSwitchAccountPleaseTryAgainOrContactSupport')
          : formatMessageOutsideReact(messages.switchFailedContactIt),
      });
    },
  });
}
